(function($) {
  "use strict";
  $(function() {
    if ($("#js-sheet-url").length === 0) {
      return;
    }

    const csvUrl = $("#js-sheet-url")
      .val()
      .trim();

    fetch(csvUrl)
      .then((res) => res.text())
      .then((csv) => {
        const clean = DOMPurify.sanitize(csv);
        const parsed = Papa.parse(clean.trim(), { header: false });
        const rows = parsed.data;
        rows.shift(); // remove headers

        const structured = {};

        rows.forEach((cols) => {
          if (cols.length < 5) return;

          const ital = cols[0].trim();
          const menny = cols[1].trim();
          const ar = cols[2].trim();
          const kategoria = cols[3].trim() || localize.translations.other;
          const alkategoria = cols[4].trim() || "nincs";
          const leiras = cols[5] ? cols[5].trim() : "";

          if (!structured[kategoria]) {
            structured[kategoria] = {};
          }

          if (!structured[kategoria][alkategoria]) {
            structured[kategoria][alkategoria] = {};
          }

          if (!structured[kategoria][alkategoria][ital]) {
            structured[kategoria][alkategoria][ital] = [];
          }

          structured[kategoria][alkategoria][ital].push({
            menny,
            ar,
            leiras,
          });
        });

        renderMenuFromSheet(structured);
        generateMenuCategoryNav(Object.keys(structured));
      });

    const renderMenuFromSheet = (data) => {
      const wrapper = document.getElementById("js-menu-content");
      wrapper.innerHTML = "";

      Object.entries(data).forEach(([mainCat, subcats]) => {
        const catId = slugify(mainCat);

        const main = document.createElement("div");
        main.className = "menu__content_inner js-main-category";
        main.id = catId;

        main.innerHTML = `
        <h4 class="category__title">${mainCat}</h4>
        <p class="no__result js-no-result">${localize.translations.no_result}</p>
      `;

        Object.entries(subcats).forEach(([subCat, drinks]) => {
          const sub = document.createElement("div");
          sub.className = "sub__category_wrapper js-sub-category";

          if (subCat !== "nincs") {
            sub.innerHTML += `<h1 class="sub__category_title">${subCat}</h1>`;
          }

          Object.entries(drinks).forEach(([name, prices]) => {
            const card = document.createElement("div");
            card.className = "card__menu js-card-menu";

            const leiras = prices[0].leiras?.trim() || "";

            card.innerHTML = `
              <h2 class="js-card-title">${name}</h2>
              ${leiras ? `<p class="js-card-description">${leiras}</p>` : ""}
              <ul class="prices__wrapper">
                ${prices
                  .map(
                    (p) => `
                      <li class="price__item">
                        ${
                          p.menny
                            ? `<span class="price__prefix">${p.menny}</span>`
                            : ""
                        }
                        ${p.ar ? `<span class="price">${p.ar}</span>` : ""}
                      </li>
                    `
                  )
                  .join("")}
              </ul>
            `;

            sub.appendChild(card);
          });

          main.appendChild(sub);
        });

        wrapper.appendChild(main);
      });
    };

    const slugify = (str) => {
      return str
        .toLowerCase()
        .replace(/á/g, "a")
        .replace(/é/g, "e")
        .replace(/í/g, "i")
        .replace(/ó|ö|ő/g, "o")
        .replace(/ú|ü|ű/g, "u")
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9\-]/g, "");
    };

    const generateMenuCategoryNav = (categories) => {
      const ul = document.getElementById("sheet-category-nav");
      ul.innerHTML = "";

      categories.forEach((k) => {
        const li = document.createElement("li");
        li.className = `menu__category_item js-menu-category-item ${slugify(
          k
        )}`;

        li.innerHTML = `
        <a class="category__item js-go-to-menu-category" href="#${slugify(k)}">
          ${k}
        </a>
      `;

        ul.appendChild(li);
      });

      initStickyCategoryScroll();
    };

    const scrollToHashIfPresent = () => {
      const hash = window.location.hash;
      if (!hash || hash === "#filter") return;

      const $target = $(hash);
      if ($target.length) {
        $("html, body").animate(
          {
            scrollTop: $target.offset().top - $(".js-header").height() - 10,
          },
          1000
        );
      }
    };

    const initStickyCategoryScroll = () => {
      const $menu = $(".js-sticky-menu-category");
      let id = false;
      let sections = [];

      const hash = function(h) {
        if (history.pushState) {
          history.pushState(null, null, h);
        } else {
          location.hash = h;
        }
      };

      $menu.on("click", "a", function(event) {
        event.preventDefault();
        const target = $(this).attr("href");

        if (target.length === 0) {
          return;
        }

        $("html, body").animate(
          {
            scrollTop: $(target).offset().top - $(".js-header").height() - 10,
          },
          {
            duration: 700,
            complete: () => hash(target),
          }
        );
      });

      const $menu_a = $("a", $menu);
      sections = [];
      $menu_a.each(function() {
        sections.push($($(this).attr("href")));
      });

      scrollToHashIfPresent();
    };
  });
})(jQuery);
